// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// TRACKING
const EVENTNAME = 'GAEvent'
const CATEGORY = 'Clash 2018'
const EXCLUDE_REGIONS = ['jp', 'kr', 'ru', 'zh']

Vue.mixin({
  computed: {
    isIE () {
      let ua = window.navigator.userAgent
      let msie = ua.indexOf('MSIE ')
      let trident = ua.indexOf('Trident/')
      let edge = ua.indexOf('Edge/')

      if (msie > 0 || trident > 0 || edge > 0) {
        return true
      }

      return false
    },
    isIE11 () {
      let ua = window.navigator.userAgent
      return ua.indexOf('Trident/7.0') > 0
    },
    disableCustomNames () {
      return EXCLUDE_REGIONS.includes(window.clash2018.region)
    },
    currentRegion () {
      return window.clash2018.region
    }
  },
  methods: {
    trackEvent (action = '', label = '') {
      let trackObj = {
        'event': EVENTNAME,
        'category': CATEGORY,
        'action': action
      }
      if (label.length > 0) {
        trackObj['label'] = label
      }

      // if (dataLayer && process.env.NODE_ENV !== 'development') {
      if (window.dataLayer) {
        window.dataLayer.push(trackObj)
      }
      // }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js